'use strict';

module.exports = function (formSelector, buttonSelector) {
	window.jQuery(formSelector).on('submit', function () {
		window.jQuery(buttonSelector).addClass('disabled').attr('disabled', 'disabled');
	});

	return function reEnableButton() {
		window.jQuery(buttonSelector).removeClass('disabled').removeAttr('disabled');
	};
};
